import React from "react";
import Section from "./Section";
import { FiSmartphone, FiServer, FiRepeat, FiCreditCard } from "react-icons/fi";

const items = [
  {
    icon: <FiSmartphone />,
    title: "Ship the app",
    desc: "Mobile apps with clean UX, auth, offline support, release builds, and store delivery.",
  },
  {
    icon: <FiServer />,
    title: "Build the backend",
    desc: "Backend systems, APIs, database design, admin workflows, auth, deployment, logs, and maintainable architecture.",
  },
  {
    icon: <FiCreditCard />,
    title: "Handle money flows",
    desc: "Payments, subscriptions, in-app purchases, wallet-style flows, webhook handling, and transaction states.",
  },
  {
    icon: <FiRepeat />,
    title: "Fix what is stuck",
    desc: "Refactors, performance work, crash fixes, API cleanup, release blockers, and legacy code stabilization.",
  },
];

export default function Services() {
  return (
    <Section id="services" subtitle="How I help" title="From idea to shipped product">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {items.map((it) => (
          <div key={it.title} className="border-2 border-black/15 dark:border-white/20 p-6 bg-white/80 dark:bg-black/50 hover:border-black dark:hover:border-white transition-colors">
            <div className="text-black dark:text-white text-xl">{it.icon}</div>
            <h3 className="mt-4 font-display text-xl font-semibold text-black dark:text-white">{it.title}</h3>
            <p className="mt-2 text-sm text-stone-600 dark:text-stone-400 leading-relaxed">{it.desc}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}
